<template>
    <!-- :append-icon="showSsn ? 'mdi-eye' : 'mdi-eye-off'" -->
    <TextField
        :id="id"
        ref="field"
        v-model="inputVal"
        v-bind="$attrs"
        inputmode="numeric"
        :mask="ssnMask"
        :required="required"
        v-on="$listeners"
        :append-icon="showSsn ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="toggleShowSsn"
        @focus="focus"
        @blur="blur"
    >
        <template #label
            ><slot name="label">{{ $attrs.label }}</slot></template
        >

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </TextField>
</template>

<script>
    import { validSsn } from "@/util/validation"
    import FieldProxyMixin from "@/components/form/FieldProxyMixin.vue"
    import mask from "@/util/mask"

    const hiddenMask = "xxx-xx-0000"

    export default {
        mixins: [FieldProxyMixin],

        inheritAttrs: true,

        props: {
            autoShow: Boolean,
        },

        data() {
            return {
                ssnMask: {
                    mask: hiddenMask,
                    definitions: {
                        x: mask.star,
                    },
                },
                showSsn: false,
            }
        },

        mounted() {
            this.$refs.field.$el.querySelector(".v-icon").setAttribute("tabindex", "-1")
        },

        methods: {
            focus() {
                if (this.autoShow) {
                    setTimeout(() => {
                        this.setSsnVisible(true)
                    })
                }
            },

            blur() {
                if (this.autoShow) {
                    setTimeout(() => {
                        this.setSsnVisible(false)
                    })
                }
            },

            setSsnVisible(flag) {
                this.showSsn = flag
                this.ssnMask = { ...this.ssnMask, mask: this.showSsn ? mask.ssn : hiddenMask }
            },

            toggleShowSsn() {
                this.setSsnVisible(!this.showSsn)
            },

            validationSource: function (target, field) {
                field.applyValidator(target, validSsn.id, validSsn)
            },
        },
    }
</script>
